// extracted by mini-css-extract-plugin
export default {"toggle-button-wrapper":"ToggleButton_toggle-button-wrapper__oG061","toggle-button":"ToggleButton_toggle-button__35yaV"};